const recuperacionDeContrasena = {
    ObtenUsuarios: 'SICUS/RecuperacionDeContrasena/ObtenUsuarios',
    ObtenLaContrasenaDelUsuario: 'SICUS/RecuperacionDeContrasena/ObtenLaContrasenaDelUsuario',
    EnviarCorreoElectronico: 'SICUS/RecuperacionDeContrasena/EnviarCorreoElectronico',
    ActualizaContrasenaDeMajat: 'SICUS/RecuperacionDeContrasena/ActualizaContrasenaDeMajat'
}

const permisosDelUsuario = {
    ObtenUsuarios: 'SICUS/PermisosDelUsuario/ObtenUsuarios',
    ObtenLosPermisosDelUsuarioYSistema: 'SICUS/PermisosDelUsuario/ObtenLosPermisosDelUsuarioYSistema', 
    GuardarPermisosDelUsuario: 'SICUS/PermisosDelUsuario/GuardarPermisosDelUsuario'
}

const ajustesDeUsuarios = {
    ObtenUsuarios: 'SICUS/AjustesDeUsuarios/ObtenUsuarios',
    ObtenUsuario: 'SICUS/AjustesDeUsuarios/ObtenUsuario', 
    ModificaElEstatusDelUsuario: 'SICUS/AjustesDeUsuarios/ModificaElEstatusDelUsuario',
    ActualizaLaInformacionDelUsuario: 'SICUS/AjustesDeUsuarios/ActualizaLaInformacionDelUsuario'
}
 
const usuarios = {
    recuperacionDeContrasena: recuperacionDeContrasena, 
    permisosDelUsuario: permisosDelUsuario, 
    ajustesDeUsuarios: ajustesDeUsuarios
}

export default usuarios;


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SICUS/sistema/usuarios/usuarios.js
// module id = null
// module chunks = 